import createTaskAction from '@esentai/core/ducks/tasks/createTaskAction';

import { UPDATE_BRAND } from './types';

export const updateBrand = createTaskAction(UPDATE_BRAND);
